module.exports = __webpack_public_path__ + "images/emoji/thought_balloon.40aa1ba3c1ddf2882aac.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/thought_balloon.png
// module id = 3/LE
// module chunks = 14